/** @jsxImportSource @emotion/react */
import React from 'react'

import FlexGrid from '../../../../components/structure/FlexGrid'
import ReplyPanel from './ReplyPanel'

import { css } from '@emotion/react'

const RepliesList = ({ replies, components, allReplies, isChild, props }) => {
  if (!replies.length) return false

  return (
    <ReplyWrapper isChild={isChild}>
      {replies.map(reply => (
        <ReplyPanel
          key={reply.id + '_' + reply.question?.id}
          reply={reply}
          replies={replies}
          allReplies={allReplies}
          ref={el => (components.current[reply.question?.id] = el)}
          {...props}
        />
      ))}
    </ReplyWrapper>
  )
}

const ReplyWrapper = ({ isChild, children }) => {
  const style = css`
    margin: 0 -19px -19px -19px;
    padding: 0.75rem 0.5rem;
    background: #f6f6f6;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border-top: solid 1px #d3d7e8;
    border-radius: 5px;
  `

  if (isChild) {
    return <div css={style}>{children}</div>
  }

  return (
    <FlexGrid align="stretch" justify="flex-start" direction="column" gutter={0.5}>
      {children}
    </FlexGrid>
  )
}

export default RepliesList
